<template>
  <div class="cargo-type-component">
    <v-row>
      <v-col class="text-center pt-3" sm="6" md="1">
        <v-icon large>fas fa-archive</v-icon>
        <h3>{{$t('orders.box')}}</h3>
      </v-col>
      <v-col class="text-center hidden-md-and-up" align-self="center" md="6">
        <v-btn text icon color="kazan" v-on:click="cloneCargoType(cargoItem)">
          <v-icon>fas fa-clone</v-icon>
        </v-btn>
        <v-btn text icon color="kazan" v-on:click="removeCargoType(index)">
          <v-icon>fas fa-times</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="12" md="10">
        <v-row>
          <v-col cols="6" sm="4" md="2">
            <label for="length">{{$t('orders.length')}} *</label>
            <v-text-field
              v-model="cargoItem.length"
              background-color="#dbdbdb"
              solo
              single-line
              suffix="cm"
              type="number"
              :rules="cargoRules"
            ></v-text-field>
          </v-col>
          <v-col cols="6" sm="4" md="2">
            <label for="width">{{$t('orders.width')}} *</label>
            <v-text-field
              v-model="cargoItem.width"
              background-color="#dbdbdb"
              solo
              single-line
              suffix="cm"
              type="number"
              :rules="cargoRules"
            ></v-text-field>
          </v-col>
          <v-col cols="6" sm="4" md="2">
            <label for="height">{{$t('orders.height')}} *</label>
            <v-text-field
              v-model="cargoItem.height"
              background-color="#dbdbdb"
              solo
              single-line
              suffix="cm"
              type="number"
              :rules="cargoRules"
            ></v-text-field>
          </v-col>
          <v-col cols="6" sm="4" md="2">
            <label for="weight">{{$t('orders.weight')}} *</label>
            <v-text-field
              v-model="cargoItem.weight"
              background-color="#dbdbdb"
              solo
              single-line
              :suffix="$t('orders.kg_piece')"
              type="number"
              :rules="cargoRules"
            ></v-text-field>
          </v-col>
          <v-col cols="6" sm="4" md="4">
            <label for="description">{{$t('orders.description')}}</label>
            <v-text-field
              v-model="cargoItem.description"
              background-color="#dbdbdb"
              solo
              single-line
            ></v-text-field>
          </v-col>
          <!-- <v-flex xs6 sm4 md2>
            <label for="quantity">{{$t('orders.quantity')}} *</label>
            <v-text-field
              v-model="cargoItem.quantity"
              background-color="#dbdbdb"
              solo
              single-line
              type="number"
              :rules="cargoRules"
            ></v-text-field>
          </v-flex>
          <v-flex xs6 sm4 md2 text-xs-center>
            <label mr-1 for="stockable">{{$t('orders.stockable')}} *</label>

            <v-layout row>
              <v-flex class="pl-4 pr-0 text-xs-right">
                <v-switch color="kazan" v-model="cargoItem.stockable" value></v-switch>
              </v-flex>
              <v-flex class="pl-0 text-xs-left">
                <v-tooltip bottom max-width="150" dark>
                  <template v-slot:activator="{ on }" >
                    <v-btn class="stockable-tooltip-btn" text icon v-on="on" color="kazan">
                      <v-icon>help</v-icon>
                    </v-btn>
                  </template>
                  <span>{{$t('orders.stockable_tooltip')}}</span>
                </v-tooltip>
              </v-flex>
            </v-layout>
          </v-flex> -->
        </v-row>
      </v-col>
      <v-col class="hidden-sm-and-down pl-0" align-self="center" md="1" >
        <v-btn text icon color="kazan" @click="cloneCargoType()">
          <v-icon>fas fa-clone</v-icon>
        </v-btn>
        <v-btn text icon color="kazan" @click="removeCargoType()">
          <v-icon>fas fa-times</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'OrderFormCargoItem',
  props: ['cargoItem', 'index'],
  data () {
    return {
      mesurmentUnits: ['cm', 'm'],
      weightUnits: ['kg', 't'],
      cargoRules: [
        v => !!v || this.$i18n.t('general.required_field'),
        v => v > 0 || this.$i18n.t('general.greater_then_zero')
      ]
    }
  },
  methods: {
    removeCargoType: function () {
      this.$emit('remove-cargo', this.index)
    },
    cloneCargoType: function () {
      this.$emit('clone-cargo', this.cargoItem)
    }
  }
}
</script>

<style lang="scss" scoped>
    .cargo-type-component {
        padding: 15px 0;
        border-bottom: 1px solid #e2e2e2;
        margin-bottom: 10px;
    }
    .cargo-type-component h3 {
        margin-top: 4px;
    }
    .mesurment-units-selector {
        margin-top: 20px;
    }
    button {
        margin-left: 0;
        margin-right: 0;
    }
    .stockable-tooltip-btn {
        margin: 0 0 0 0;
        height: 22px;
        width: 22px;
    }
    ::v-deep .v-text-field.v-text-field--enclosed>.v-input__control>.v-input__slot {
      padding: 0 6px;
    }
    ::v-deep .v-text-field__suffix {
      font-size: 10px;
    }

    ::v-deep .v-input--selection-controls {
      margin-top: 0;
      padding-top: 0;
    }

</style>
